import React from "react";
import Widget from "components/Widget";
import { Col } from 'antd';
import DigitalKobiList from './DigitalKobiList'
import { useMediaQuery } from 'react-responsive'

const TicketList = (props) => {
    const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });

    return (
        isDesktopOrLaptop ?
            <Widget 

                title={
                                <h2 className="gx-text-capitalize gx-mb-0">{props.IsEInvoice ? 'E-Fatura Listesi' : 'E-Arşiv Listesi'}</h2>
                            }
                            extra={
                                <h2 className="gx-text-primary gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
                    <a href={"/" + (props.IsEInvoice ? "EinvoiceList" : "EArchiveList")} className="ak-jumbo-grey-text">Tümü 
                    <img src={require(`assets/images/Icons/ChevronLeft.svg`)} alt="icon" style={{ marginLeft: 20,width: 35, height: 35 }} /></a> 
                                </h2> 
                            }
                        >  

                <div key={"TicketItem"} className="gx-media gx-task-list-item gx-flex-nowrap">
                    <Col span={24} style={{ width: 700, overflowY: 'auto' }}>
                        <DigitalKobiList isDigitHomePage={props.isDigitHomePage} IsEInvoice={props.IsEInvoice} />
                    </Col>
                </div>
            </Widget>
            :
            <Widget title={<h2 className="h4 gx-text-capitalize gx-mb-0">{props.IsEInvoice ? 'E-Fatura Listesi' : 'E-Arşiv Listesi'}</h2>} styleName="gx-card-ticketlist"
                extra={<h5 className="gx-text-primary gx-mb-0 gx-pointer gx-d-no ne gx-d-sm-block"> </h5>}>
                <div key={"TicketItem"} className="gx-media gx-task-list-item gx-flex-nowrap">
                    <Col span={24} style={{ width: 700, overflowY: 'auto' }}>
                        <DigitalKobiList isDigitHomePage={props.isDigitHomePage} IsEInvoice={props.IsEInvoice} />
                    </Col>
                </div>
            </Widget>
    );
}


export default TicketList;
